import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'
import { format } from '../../../../../common/services/date.service'

export default function TenantConfigurationInfoComponent ({tenantsDetails}: any) {

  return (
    <>
      <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                    <InputLabelContainer
          label="Storage Account Name"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.StorageAccountName}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Resource GroupName"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.ResourceGroupName}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Subscription Id"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.SubscriptionId}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Tenant Id"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.TenantId}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Client Secrets"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.ClientSecrets}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="Client Id"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.ClientId}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="OpenNetwork Subscriber Id"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.OpenNetworkSubscriberId}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="OpenNetwork Subscriber URL"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.OpenNetworkSubscriberURL}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="OpenNetwork Subscriber URL"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Storage?.OpenNetworkSubscriberURL}
  />
                    </div>

                    
      
        </div>
      }
        expandedPanel="Storage"
        headerTitle="Storage"
      />


<AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                    <InputLabelContainer
          label="Email"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.Email}
  />


                    </div>
                    <div>
                    <InputLabelContainer
          label="Host"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.Host}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Port"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.Port}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Username"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.Username}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Password"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.Password}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="EnableSsl"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.EnableSsl}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="UseDefaultCredentials"
      />
  <InputLabelContainer
      label={tenantsDetails?.Configurations?.Email?.UseDefaultCredentials}
  />
                    </div>
        </div>
      }
        expandedPanel="Email"
        headerTitle="Email"
      />


    </>
  )
}